module.exports = "<div class=\"kl-treeview {class}\" r-class={ {'kl-treeview--multiple': multiple} } r-hide={!visible}>\n\t<kl-tree body={this.$body}\n             source={source}\n             childKey={childKey}\n             nameKey={nameKey}\n             key={key}\n             separator={separator}\n             visible\n             multiple={multiple}\n             value={value}\n             selected={selected}\n             on-setselected={this.setSelected($event)} />\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/form/KLTreeView/index.html
// module id = 368
// module chunks = 0